/*
 * Clique no botão "+" do card de produto — ADICIONA DIRETO ao carrinho.
 *
 * O modal de seleção de variante/quantidade (`<dialog class="pqa-modal">`) foi
 * REMOVIDO a pedido da usuária (jul/2026): as pílulas de peso já estão no próprio
 * card, então o modal era um passo redundante. Antes, o comportamento era:
 * variante única -> add direto; mais de uma variante -> abria o modal. Agora é
 * sempre add direto, em TODOS os cards do site (home/Destaques, coleção, busca,
 * relacionados e "Compre junto") — o handler é global, por delegação.
 *
 * Como a variante certa é enviada: `assets/premier-card-actions.js` (clique nas
 * pílulas) mantém o input hidden `[data-pcard-id]` — que é o mesmo com
 * `ref="variantId"` do form — sincronizado com a pílula ativa. Aqui só disparamos
 * o submit real (`.pcard-submit`), que está dentro de <add-to-cart-component>, ou
 * seja: mantém o AJAX nativo + atualização de ícone/drawer + animação fly-to-cart.
 *
 * Obs.: `assets/premier-quickadd.css` (estilos do .pqa-modal) ficou órfião — não
 * casa com nada agora. Não foi removido porque o MCP do Shopify bloqueia
 * themeFilesDelete; é inofensivo (apenas CSS morto).
 *
 * ---------------------------------------------------------------------------
 * ARCO DA ANIMAÇÃO (fly-to-cart) — por que trocamos a classe
 * ---------------------------------------------------------------------------
 * O <fly-to-cart> nativo anima X e Y com curvas separadas. A classe que o tema
 * escolhe pra botões que NÃO são quick-add é `fly-to-cart--main`, cujo X usa
 * `cubic-bezier(.7, -5, .98, .5)`. Esse `-5` faz o X RECUAR antes de seguir pro
 * carrinho, e o recuo é PROPORCIONAL à distância percorrida: medido, a curva chega
 * a **-2.085x** o deslocamento. Na PDP isso é inofensivo (travelX ~175px, o recuo
 * fica dentro da tela), mas num card da home/coleção o travelX chega a ~920px, e a
 * mini imagem ia até x = -1627 num viewport de 1280 — saindo completamente da tela.
 * Quanto mais à esquerda o card, maior o arco (bug reportado pela usuária).
 *
 * FIX: os voos que saem de um CARD passam a usar `fly-to-cart--quick`, a variante
 * que o próprio tema criou pra quick-add em card — X = `cubic-bezier(0, -.1, 1, .32)`,
 * mínimo **-0.015** (praticamente sem recuo), com o arco vindo do eixo Y. Assim o
 * arco fica suave e igual saindo de qualquer card, independente da distância.
 * A PDP NÃO é afetada: ela continua no `--main` (não passa por este handler).
 *
 * Timing: `AddToCartComponent#animateFlyToCart()` cria e anexa o <fly-to-cart>
 * SINCRONAMENTE dentro do handleClick nativo, então logo após `btn.click()` o
 * elemento já existe no DOM e ainda não começou a animar (o start só acontece
 * depois do callback do IntersectionObserver que mede as posições) — dá tempo de
 * trocar a classe com segurança.
 */
(function () {
  if (window.__pqa) return;
  window.__pqa = true;

  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('[data-pqa-open]');
    if (!plus) return;
    e.preventDefault();

    var actions = plus.closest('.pcard-actions');
    if (!actions) return;

    var btn = actions.querySelector('.pcard-submit');
    if (!btn || btn.disabled) return;

    btn.click();

    var flights = document.querySelectorAll('fly-to-cart');
    var el = flights[flights.length - 1];
    if (el && el.classList.contains('fly-to-cart--main')) {
      el.classList.remove('fly-to-cart--main');
      el.classList.add('fly-to-cart--quick');
    }
  });
})();
